/**
 * Returns the provided value if it is not falsy, otherwise returns the default value.
 *
 * This function intentionally uses the `||` operator instead of the `??` operator to also handle cases where the value is an empty string, 0 or false.
 *
 * @param {T | null | undefined} value - The value to check.
 * @param {T} defaultValue - The default value to return if the provided value is falsy.
 * @returns {T} - The provided value if it is not falsy, otherwise the default value.
 */
export const getDefaultValue = (value, defaultValue) => value || defaultValue;
//# sourceMappingURL=getDefaultValue.js.map